<template>
 	<div class="flex-colum h-100">
		<div class="d-flex justify-content-between bd-highlight mb-3">
		    <div class="align-self-center mb-3" style="height: 30px;">
		        <button type="button" class="btn btn-primary" @click="openAddActivityDialog">添加</button>
		    </div>
		    <div class="input-group align-self-center ms-auto p-2 bd-highlight" style="width: 25%;">
		        <input type="text" id="activity-keywords" class="form-control" v-model="keywords">
		        <button class="btn btn-outline-secondary" type="button" @click="searchActivity">搜索</button>
		    </div>
		</div>
		<div>
			<table class="table table-bordered table-striped table-sm member-list">
				<thead>
					<tr>
						<th scope="col">序号</th><th scope="col">标题</th><th scope="col">门店</th><th scope="col">时间</th><th scope="col">操作</th>
					</tr>
				</thead>
				<tbody id="member-list">
					<tr v-for="(value, idx) in dataList" :key='idx'>
						<td>{{50 * (nowPage - 1) + idx + 1}}</td>
						<td>{{value.title}}</td>
						<td>{{(value.shopInfo) ? value.shopInfo.name : "未知"}}</td>
						<td>{{value.startTime}} 至 {{value.endTime}}</td>
						<td>
							<div class="flex-row flex-align-center">
								<img class="button-icon" src="/assets/ic_edit.png" @click="openEditActivityDialog(value.id)"/>
								<img class="button-icon img-margin" src="/assets/ic_trash.png" @click="deleteActivity(value.id, value.title)"/>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			<Pagination :page='nowPage' :max='totalPage/50' @loadPage="loadActivityList" />
		</div>
	</div>
	
	<AddActivityDialog :show='showAddDialog' :item='editing' @cancel='showAddDialog = false' @confirm='editActivity'/>
	<LoadingDialog :show='showLoadingDialog' />
</template>

<script lang="ts">
import { reactive, toRefs, defineComponent, nextTick, onMounted, ref, watch, computed } from 'vue';
import Pagination from '@/components/Pagination.vue';
import AddActivityDialog from '@/modals/AddActivityDialog.vue';
import LoadingDialog from '@/modals/LoadingDialog.vue';
import request from "@/global";
import { checkResponseDataAndAlert, dateFtt } from '@/common/util';

export default({
	components: { Pagination, AddActivityDialog, LoadingDialog },
	setup() {
		const refData = reactive({
			showAddDialog: false,
			showLoadingDialog: false,
			keywords: "搜索",
			editing: {}
		});
		
		const totalPage = ref<number>(0);
		const nowPage = ref<number>(1);
		const dataList = ref<any[]>([]);
		
		//needed in case we switch in from another window
		onMounted(async () => {
		  await loadActivityList(1);
		});
		
		// ========================文章标签========================
		// 添加标签
		const openAddActivityDialog = () => {
			refData.editing = {};
			refData.showAddDialog = true;
		};
		
		// 编辑信息
		const openEditActivityDialog = async (id: string) => {
		    const errMsg = "查询信息失败";
			try {
				const data = (await request({url: `activity/${id}`, get: true})).data;
		        if (checkResponseDataAndAlert(data, errMsg) && data.data) {
					data.data.show = (data.data.show === 1)
					refData.editing = data.data;
					refData.showAddDialog = true;
		        }
			} catch (e) {
				console.log(e);
				checkResponseDataAndAlert({}, errMsg);
			}
		}
		
		// 编辑
		const editActivity = async (postObj: any) =>  {
			console.log(postObj)
		    const errMsg = `操作失败`;		
			if (!postObj.title || postObj.title.length < 2
				|| !postObj.shop || postObj.shop.length < 2
				|| !postObj.detail || postObj.detail.length < 2
				|| !postObj.startTime || postObj.startTime.length < 2
				|| !postObj.endTime || postObj.endTime.length < 2
				|| !postObj.image || postObj.image.length < 2) {
				alert("请完善带*的必填项");
				return;
			}
		
		    refData.showLoadingDialog = true;
			try {
				const data = (await request({url: `activity/save`, data: postObj})).data;
				refData.showLoadingDialog = false;
		        if (checkResponseDataAndAlert(data, errMsg)) {
					refData.showAddDialog = false;
		            loadActivityList(nowPage.value);
		        }
			} catch (e) {
				console.log(e);
				refData.showLoadingDialog = false;
				checkResponseDataAndAlert({}, errMsg);
			}
		}
		
		// 删除
		const deleteActivity = async (card_no: string, name: string) => {
			if (confirm(`确认删除 ${name} 吗？`)) {
				const errMsg = "删除失败";
				try {
					const data = (await request({url: `activity/delete/${card_no}`, get: true})).data;
					if (checkResponseDataAndAlert(data, errMsg)) {
						alert("删除成功");
						loadActivityList(nowPage.value);
					}
				} catch (e) {
					checkResponseDataAndAlert({}, errMsg);
				}
			}
		};
		
		// 搜索
		const searchActivity = async () => {
		    if (refData.keywords.length === 0) {
		        loadActivityList(1);
		        return;
		    }
		
		    nowPage.value = 1;
			try {
				const postObj = {"page" : 1, "size": 50, "content": refData.keywords, timestamp: Date.now() };
				const data = (await request({url: `activity/search`, data: postObj})).data
		        if (checkResponseDataAndAlert(data) && data.data) {
					dataList.value = data.data;
					totalPage.value = data.total;
				}
			} catch (e) {
				checkResponseDataAndAlert({});
			}
		}
			
		// 加载列表
		const  loadActivityList = async (page: number) => {
		    if (page < 1) return;
		
		    nowPage.value = page;
			try {
				const data = (await request({url: `activity/list/${page}/${50}`, get: true})).data;
				if (checkResponseDataAndAlert(data) && data.data) {
				    dataList.value = data.data;
					totalPage.value = data.total;
				}
			} catch (e) {
				checkResponseDataAndAlert({});
			}
		};
		
		const dataRef = toRefs(refData);
		return {
			dataList,
			nowPage,
			totalPage,
			
			dateFtt,
			editActivity,
			loadActivityList,
			openAddActivityDialog,
			openEditActivityDialog,
			deleteActivity,
			
			...dataRef
		};
	},
});
</script>

<style>
</style>